module.exports = __webpack_public_path__ + "img/59.dcfc9ac3.svg";